import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { Input, Modal, PaperClip, RevisionItem, Select, WhatsAppButton } from 'components';
import ModalViewValidate from './modal-validation';
import { ServiceService, ValidationService } from 'services';
import { ArrowRight, Menu as MenuIcons } from 'assets/icons';
import {
  HomeService,
  RevisionService,
  SignatureService,
  PreparationService,
  CallService,
} from 'services';
import moment from 'moment';
import { WhiteImage, LawyerBanner } from 'assets/img';
import { useApacuana } from 'contexts/ApacuanaContext';
import { CERTIFICATES_TYPES } from 'screens/apacuana/utils';
import StatusCertificateCard from 'screens/apacuana/components/StatusCertificateCard';
import BannerUpdateDocs from './banner-update-docs';
import ModalLawyers from './modal-lawyers';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
  apacuana?: any;
  customer?: any;
  status?: any;
  cert?: any;
  onOpenGenerateForm?: any;
  onOpenRevoqueForm?: any;
}

const TYPES = {
  REVISION: 1,
  SIGNATURE: 2,
};

class Home extends React.Component<Props> {
  state = {
    visible: false,
    services_access: {} as Record<number, number>,
    revisions: [],
    signatures: [],
    preparations: [],
    calls: [],
    visible_lawyer: false,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Inicio',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.loadData();
  }

  loadData = async (withoutLoading = false) => {
    const [homeRes, statusRes, preparationRes, callsRes]: any = await Promise.all([
      HomeService.get({
        user_id: this.props.user?.id,
        withoutLoading,
      }),
      ServiceService.getStatus({
        user_id: this.props.user?.id,
      }),
      PreparationService.get({
        user_id: this.props.user?.id,
        page: 1,
        per_page: 3,
        withoutLoading,
      }),
      CallService.get({
        user_id: this.props.user?.id,
        page: 1,
        per_page: 3,
        withoutLoading,
      }),
    ]);

    // Convertir array de servicios a mapa: { service_id: access_status }
    // Ejemplo: { 1: 1, 2: 1, 3: 3, 5: 3 }
    const services_access: Record<number, number> = {};
    (statusRes?.services || []).forEach((s: any) => {
      services_access[s.id] = s.access;
    });

    this.setState({
      services_access,
      revisions: homeRes.revisions || [],
      user: homeRes.user,
      signatures: homeRes.signatures || [],
      preparations: preparationRes.rows || [],
      calls: callsRes.rows || [],
    });

    this.props.dispatch({
      type: 'SET_PLAN_USER',
      payload: homeRes.plan_user || null,
    });
  };

  add = (membership_id: number | null = null) => {
    this.props.history.push(
      `/${this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'lawyer'}/memberships/add${membership_id ? '?membership_id=' + membership_id : ''}`,
    );
  };

  sendResponse = async (item: any, file: any, type: number) => {
    if (type == TYPES.REVISION) {
      await RevisionService.saveResponse({
        file,
        revision_id: item.id,
        hasFile: true,
      });
      Globals.showSuccess('Se ha enviado el archivo correctamente');
      this.loadData(true);
    } else if (type == TYPES.SIGNATURE) {
      await SignatureService.saveResponse({
        file,
        signature_id: item.id,
        hasFile: true,
      });
      Globals.showSuccess('Se ha enviado el archivo correctamente');
      this.loadData(true);
    }
  };

  // Helper para saber si el usuario tiene acceso a un servicio
  hasAccess = (service_id: number): boolean => {
    return this.state.services_access[service_id] === Constants.ACCES_STATUS.ACCESS_GRANTED;
  };

  onOpenSearchLawyers = () => {
    this.setState({ visible_lawyer: true });
  };
  onCloseSearchLawyers = () => {
    this.setState({ visible_lawyer: false });
  };

  render() {
    const { visible } = this.state;
    const { user: apacuanaUser, sdk } = this.props.apacuana || {};
    const { customer, status, cert, onOpenGenerateForm, onOpenRevoqueForm } = this.props;
    return (
      <div id='client-home'>
        <Modal
          hideHeader={true}
          className='modal-lawyers'
          visible={this.state.visible_lawyer}
          title=''
          onClose={() => this.onCloseSearchLawyers()}
        >
          {/*
                 // @ts-ignore */}
          <ModalLawyers
            onClose={() => this.onCloseSearchLawyers()}
            navigation={this.props.history}
            plan_user={this.props.plan_user}
          />
        </Modal>

        <p className='name'>Hola, {this.props.user?.full_name}</p>

        {/* Banner: documentos en revisión o rechazados (IN_PROCESS / REJECTED) */}
        {(this.props.user?.verified === Constants.VERIFIED.IN_PROCESS ||
          this.props.user?.verified === Constants.VERIFIED.REJECTED) && (
          <BannerUpdateDocs
            verified={this.props.user?.verified}
            onUpdate={() => this.props.history.push('/lawyer/validation?replace=true')}
          />
        )}

        {/* MODO SOLO REGISTRO ABOGADO: banner permanente de validación para PENDING */}
        {this.props.user?.verified === Constants.VERIFIED.PENDING && (
          <div className='banner-verificacion'>
            <div className='banner-texto'>
              <p className='banner-titulo'>
                {/* {this.props.user?.verified == Constants.VERIFIED.REJECTED ? '⚠️ Tu validación fue rechazada' : ' */}
                ⚠️ Tu cuenta aún no está verificada{/* '} */}
              </p>
              <p className='banner-subtitulo'>
                {/* {this.props.user?.verified == Constants.VERIFIED.REJECTED ? 'Por favor carga nuevamente tus documentos para continuar.' : ' */}
                Debes cargar tus documentos y agendar una cita para poder usar la plataforma.
                {/* '} */}
              </p>
            </div>
            <div className='banner-botones'>
              <button
                className='btn'
                style={{
                  background: '#ffc107',
                  color: '#212529',
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                  borderRadius: '6px',
                  padding: '8px 18px',
                }}
                onClick={() => this.props.history.push('/lawyer/validation')}
              >
                Verificar cuenta
              </button>
              <WhatsAppButton
                phoneNumber='584225342555'
                message='Hola, quiero agendar una cita para la verificación de mi cuenta en Legalmente.'
                buttonText='Agendar cita'
                style={{
                  backgroundColor: '#ffc107',
                  color: '#212529',
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                  borderRadius: '6px',
                  padding: '8px 18px',
                  fontSize: '16px',
                }}
              />
            </div>
          </div>
        )}

        <div className='row'>
          <div className='col-md-12'>
            <div className='row'>
              {/* ── Widget: Revisión documental (service_id = REVISION = 3) ── */}
              <div className='col-md-6'>
                <div className='container-white'>
                  <div className='header-white'>
                    <div className='name-container'>
                      <div className='icon-container' style={{ backgroundColor: Colors.orange }}>
                        <img src={MenuIcons.Menu6} />
                      </div>
                      <h3>Revisión documental</h3>
                    </div>
                    <Link to='/lawyer/revision'>
                      Ver más <img src={ArrowRight} />
                    </Link>
                  </div>
                  {this.state.revisions.length == 0 && (
                    <div className='no-items'>
                      <p>No se encontraron registros</p>
                    </div>
                  )}
                  {this.state.revisions.map((item: any) => {
                    return (
                      <RevisionItem
                        sendResponse={(i: any, file: any) =>
                          this.sendResponse(i, file, TYPES.REVISION)
                        }
                        item={item}
                      />
                    );
                  })}
                </div>
              </div>

              {/* ── Widget: Elaboración documental (service_id = PREPARATION) ── */}
              <div className='col-md-6'>
                <div className='container-white'>
                  <div className='header-white'>
                    <div className='name-container'>
                      <div className='icon-container' style={{ backgroundColor: Colors.blue }}>
                        <img src={MenuIcons.Menu15} />
                      </div>
                      <h3>Elaboración documental</h3>
                    </div>
                    <Link to='/lawyer/preparation'>
                      Ver más <img src={ArrowRight} />
                    </Link>
                  </div>
                  {this.state.preparations.length == 0 && (
                    <div className='no-items'>
                      <p>No se encontraron registros</p>
                    </div>
                  )}
                  {this.state.preparations.map((item: any) => {
                    return (
                      <div className='item' key={item.id}>
                        <div className='row'>
                          <div className='col-md-6'>
                            <p className='date'>{moment(item.created_at).format('DD/MM/YYYY')}</p>
                          </div>
                          <div className='col-md-6'>
                            <p className='number'>ID {item.number_format}</p>
                          </div>
                          <div className='col-md-8'>
                            {item.user != null ? (
                              <div className='container-lawyer'>
                                <img
                                  src={
                                    item.user?.photo
                                      ? Constants.BASE_STORAGE + item.user?.photo
                                      : WhiteImage
                                  }
                                />
                                <div className='container-name'>
                                  <p className='bold'>Cliente</p>
                                  <p>{item.user?.full_name}</p>
                                </div>
                              </div>
                            ) : (
                              <div className='container-no-lawyer'>
                                <p>Sin cliente asignado</p>
                              </div>
                            )}
                          </div>
                          <div className='col-md-4 text-right'>
                            <div
                              className='container-status'
                              style={{
                                backgroundColor:
                                  item.status === Constants.PREPARATION_STATUS.FINISHED
                                    ? Colors.gray3
                                    : Colors.orange,
                              }}
                            >
                              <p>{item.status_text}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* ── Widget: Llamadas telefónicas (service_id = CALL = 2) ── */}
              {/* Solo abogados internos: los externos no ofrecen llamadas */}
              {this.props.user?.internal === Constants.LAWYER_INTERNAL.YES && (
                <div className='col-md-6'>
                  <div className='container-white'>
                    <div className='header-white'>
                      <div className='name-container'>
                        <div className='icon-container' style={{ backgroundColor: Colors.danger }}>
                          <img src={MenuIcons.Menu12} />
                        </div>
                        <h3>Llamadas telefónicas</h3>
                      </div>
                      <Link to='/lawyer/calls'>
                        Ver más <img src={ArrowRight} />
                      </Link>
                    </div>
                    {this.state.calls.length == 0 && (
                      <div className='no-items'>
                        <p>No se encontraron registros</p>
                      </div>
                    )}
                    {this.state.calls.map((item: any) => {
                      const [start, end] = (item.hour || '').split(',');
                      const toFormatStart = start ? moment(start, 'HH:mm').format('hh:mm A') : '';
                      const toFormatEnd = end ? moment(end, 'HH:mm').format('hh:mm A') : '';
                      const statusColor =
                        item.status === Constants.CALL_STATUS.RESOLVED
                          ? Colors.green
                          : item.status === Constants.CALL_STATUS.NO_RESOLVED
                            ? Colors.danger
                            : Colors.orange;
                      return (
                        <div className='item' key={item.id}>
                          <div className='row'>
                            <div className='col-md-6'>
                              <p className='date' style={{ fontSize: '14px' }}>
                                {moment(item.day).format('DD/MM/YYYY')}
                              </p>
                            </div>
                            <div className='col-md-6'>
                              <p className='number' style={{ fontSize: '14px' }}>
                                ID {item.number}
                              </p>
                            </div>
                            <div className='col-md-12'>
                              <p className='date' style={{ fontSize: '12px', marginTop: '-10px' }}>
                                {toFormatStart} a {toFormatEnd}
                              </p>
                            </div>
                            <div className='col-md-8'>
                              {item.user != null ? (
                                <div className='container-lawyer'>
                                  <img
                                    src={
                                      item.user?.photo
                                        ? Constants.BASE_STORAGE + item.user?.photo
                                        : WhiteImage
                                    }
                                  />
                                  <div className='container-name'>
                                    <p className='bold'>Cliente</p>
                                    <p>{item.user?.full_name}</p>
                                  </div>
                                </div>
                              ) : (
                                <div className='container-no-lawyer'>
                                  <p>Sin cliente asignado</p>
                                </div>
                              )}
                            </div>
                            <div className='col-md-4 text-right'>
                              <div
                                className='container-status'
                                style={{ backgroundColor: statusColor }}
                              >
                                <p>{item.status_text}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* ── Widget: Banner directorio de abogados (Comunidad de abogados) ── */}
              <div className='col-md-6'>
                {(this.props.plan_user ||
                  this.props.user?.internal === Constants.LAWYER_INTERNAL.YES) && (
                  <div
                    className='container-white container-banner'
                    onClick={() => this.onOpenSearchLawyers()}
                  >
                    <img src={LawyerBanner} />
                  </div>
                )}
              </div>

              {/* ── Widget: Firma electrónica (service_id = SIGN = 1) ── COMENTADO TEMPORALMENTE (no eliminar) ── */}
              <div className='col-md-6'>
                <div className='container-white'>
                  <div className='header-white'>
                    <div className='name-container'>
                      <div className='icon-container' style={{ backgroundColor: Colors.green }}>
                        <img src={MenuIcons.Menu7} />
                      </div>
                      <h3>Firma electrónica</h3>
                    </div>
                    {this.hasAccess(Constants.SERVICES.SIGN) ? (
                      <Link to='/lawyer/signatures'>
                        Ver más <img src={ArrowRight} />
                      </Link>
                    ) : (
                      <span
                        style={{
                          color: '#939090ff',
                          textDecoration: 'underline',
                          cursor: 'default',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                        }}
                      >
                        Ver más
                        <img
                          src={ArrowRight}
                          alt='Flecha'
                          style={{
                            width: '16px',
                            height: 'auto',
                            opacity: 0.6,
                          }}
                        />
                      </span>
                    )}
                  </div>
                  {this.state.signatures.length == 0 && (
                    <div className='no-items'>
                      <p>No se encontraron registros</p>
                    </div>
                  )}
                </div>
              </div>
              <div className='col-md-6'>
                <div className='container-white'>
                  <div className='header-white'>
                    <div className='name-container'>
                      <div className='icon-container' style={{ backgroundColor: Colors.green }}>
                        <img src={MenuIcons.Menu7} />
                      </div>
                      <h3>Solicitar firma electrónica</h3>
                    </div>
                    {apacuanaUser.apacuanaId &&
                    status &&
                    status.text &&
                    status.text == 'Verificado' ? (
                      <Link to='/client/signatures'>
                        Ver más <img src={ArrowRight} />
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                  <StatusCertificateCard
                    apacuanaUser={apacuanaUser}
                    history={this.props.history}
                    status={status}
                    cert={cert}
                    customer={customer}
                    onOpenGenerateForm={onOpenGenerateForm}
                    onOpenRevoqueForm={onOpenRevoqueForm}
                  />
                </div>
              </div>
              {/* ── FIN BLOQUE COMENTADO (Firma electrónica / Solicitar firma electrónica) ── */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const HomeWithApacuana = (props: Props) => {
  const apacuanaContext: any = useApacuana();
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState(undefined);
  const [status, setStatus] = useState(undefined);
  const [cert, setCert] = useState(undefined);
  const [openGenerateForm, setOpenGenerateForm] = useState(false);
  const [openRevoqueForm, setOpenRevoqueForm] = useState(false);
  const [password, setPassword] = useState('');
  const [reasons, setReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState('');

  const init = async () => {
    setLoading(true);
    if (apacuanaContext?.isInitialized) {
      try {
        if (apacuanaContext?.user?.apacuanaId) {
          const customer = await apacuanaContext?.sdk?.getCustomer();
          setCustomer(customer?.data?.userData);
        }
        const status = await apacuanaContext?.sdk?.getCertStatus();
        const certTypesList = await apacuanaContext?.sdk?.getCertTypes();
        const certTypes = certTypesList?.data?.records || [];
        const currentCertType = certTypes.find(
          (el: any) => el.handler === CERTIFICATES_TYPES[apacuanaContext.user.level.name],
        );
        const certRequirements = await apacuanaContext?.sdk?.getCertRequerimentsByType({
          type: Number(currentCertType.id),
        });

        setStatus(status?.data?.status);
        setCert({
          ...currentCertType,
          documents: certRequirements.data.records,
        });
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  const getRequestRevocations = async () => {
    setLoading(true);
    try {
      const response = await apacuanaContext?.sdk?.getRevocationReasons();
      setReasons(response.data.reasons);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const requestRevocations = async () => {
    setLoading(true);
    try {
      await apacuanaContext?.sdk?.requestRevocation({
        reasonCode: Number(selectedReason),
      });
      const status = await apacuanaContext?.sdk?.getCertStatus();
      setStatus(status?.data?.status);

      setOpenRevoqueForm(false);
      setReasons([]);
      setSelectedReason('');
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const generateCert = async () => {
    setLoading(true);
    try {
      await apacuanaContext?.sdk?.generateCert(password);
      const status = await apacuanaContext?.sdk?.getCertStatus();
      setStatus(status?.data?.status);
      setOpenGenerateForm(false);
      Globals.showSuccess(
        '¡Solicitud completada! Su certificado digital se encuentra en proceso de emisión.',
      );
    } catch (error) {
      console.error('Error al crear el usuario:', error);
    } finally {
      setLoading(false);
    }
  };

  const onOpenGenerateForm = () => {
    setOpenGenerateForm(true);
  };

  const onOpenRevoqueForm = () => {
    setOpenRevoqueForm(true);
  };

  useEffect(() => {
    if (loading) {
      Globals.setLoading();
    } else {
      Globals.quitLoading();
    }
  }, [loading]);

  useEffect(() => {
    init();
  }, [apacuanaContext?.isInitialized, apacuanaContext?.user?.apacuanaId]);

  useEffect(() => {
    if (openRevoqueForm) {
      getRequestRevocations();
    }
  }, [openRevoqueForm]);
  return (
    <>
      <Home
        {...props}
        apacuana={apacuanaContext} // <-- PASAMOS EL CONTEXTO COMPLETO
        customer={customer}
        status={status}
        cert={cert}
        onOpenGenerateForm={onOpenGenerateForm}
        onOpenRevoqueForm={onOpenRevoqueForm}
      />
      {openGenerateForm && (
        <div
          className='modal fade show'
          tabIndex={-1}
          role='dialog'
          style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <div className='modal-dialog modal-dialog-centered' role='document'>
            <div className='modal-content'>
              <div className='modal-header' style={{ background: '#fff' }}>
                <h5 className='modal-title'>Generación de certificado electrónico</h5>
                <span
                  className='btn-close'
                  onClick={() => setOpenGenerateForm(false)}
                  aria-label='Close'
                  style={{ fontWeight: 700, cursor: 'pointer' }}
                >
                  X
                </span>
              </div>

              <div className='modal-body' style={{ background: '#fff' }}>
                <div className='container-fluid'>
                  <p className='text-secondary' style={{ fontSize: '1rem' }}>
                    Debe ingresar una contraseña alfanumérica y guardarla de forma segura.
                  </p>
                  <p className='text-secondary' style={{ fontSize: '1rem' }}>
                    La contraseña no se puede recuperar a través del sistema. Si la olvida, perderá
                    el acceso a su certificado y deberá solicitar la revocación.
                  </p>
                  <div>
                    <div className='col-md-12' style={{ padding: 0 }}>
                      <Input
                        maxLength={12}
                        type='password'
                        color='white'
                        name='phone_10'
                        label='Contraseña'
                        onChange={(e: any) => setPassword(e.target.value)}
                      />
                    </div>
                  </div>

                  <button
                    style={{
                      width: '100%',
                      backgroundColor: '#0777FF !important',
                      color: '#fff',
                    }}
                    type='button'
                    disabled={password.length < 8}
                    className={`btn btn-report ${'active'}`}
                    onClick={() => generateCert()}
                  >
                    Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {openRevoqueForm && reasons.length > 0 && (
        <div
          className='modal fade show'
          tabIndex={-1}
          role='dialog'
          style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <div className='modal-dialog modal-dialog-centered' role='document'>
            <div className='modal-content'>
              {/* HEADER */}
              <div className='modal-header' style={{ background: '#fff' }}>
                <h5 className='modal-title'>Solicitud de revocación de certificado electrónico</h5>
                <span
                  className='btn-close'
                  onClick={() => {
                    setOpenRevoqueForm(false);
                    setReasons([]);
                    setSelectedReason('');
                  }}
                  aria-label='Close'
                  style={{ fontWeight: 700, cursor: 'pointer' }}
                >
                  X
                </span>
              </div>

              {/* BODY */}
              <div className='modal-body' style={{ background: '#fff' }}>
                <div className='container-fluid'>
                  <p className='text-secondary' style={{ fontSize: '1rem' }}>
                    Al enviar la solicitud de revocación, su certificado digital queda
                    inmediatamente inactivo y no podrá utilizarse para firmar documentos hasta que
                    el proceso finalice.
                  </p>
                  <p className='text-secondary' style={{ fontSize: '1rem' }}>
                    Una vez que la solicitud sea completada, deberá generar un certificado nuevo
                    para reestablecer sus capacidades de firma.{' '}
                  </p>
                  <div>
                    <div className='col-md-12' style={{ padding: 0 }}>
                      <Select
                        label='Motivo'
                        color='white'
                        placeholder='Motivo de revocación'
                        name='bank_id'
                        onChange={(e: any) => setSelectedReason(e.target.value)}
                        value={selectedReason}
                        options={reasons.map((item: any) => {
                          return {
                            value: item.id,
                            label: item.reason,
                          };
                        })}
                      />
                    </div>
                  </div>

                  <button
                    style={{
                      width: '100%',
                      backgroundColor: '#0777FF !important',
                      color: '#fff',
                    }}
                    type='button'
                    disabled={selectedReason === ''}
                    className={`btn btn-report ${'active'}`}
                    onClick={() => requestRevocations()}
                  >
                    Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default connect((state: RootState) => {
  return {
    user: state.user,
    plan_user: state.plan_user,
  };
})(HomeWithApacuana);
